import React, { useCallback, useEffect, useRef, useState } from "react";
import { Image as ImageIcon, Upload, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, API, formatApiError } from "@/lib/api";

const SLUGS = [
  { slug: "reservas", label: "Reservaí Dubal" },
  { slug: "dayuse", label: "DayUse / Rotativo" },
  { slug: "bar", label: "Bar e Cardápio" },
  { slug: "instagram", label: "Instagram" },
  { slug: "torneio", label: "Torneio" },
  { slug: "bar_header", label: "Topo do Bar (atrás da logo)" },
];

export default function MenuBackgroundsManager() {
  const [mbg, setMbg] = useState({});
  const refs = useRef({});

  const load = useCallback(async () => {
    try { const res = await api.get("/settings"); setMbg(res.data.menu_bg || {}); } catch (e) { /* ignore */ }
  }, []);
  useEffect(() => { load(); }, [load]);

  const onFile = async (slug, e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try { await api.post(`/admin/menu-bg/${slug}`, fd); await load(); toast.success("Fundo atualizado!"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const remove = async (slug) => {
    try { await api.delete(`/admin/menu-bg/${slug}`); await load(); toast.success("Fundo removido."); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <div className="mb-8" data-testid="menu-bg-manager">
      <div className="flex items-center gap-2">
        <ImageIcon className="h-5 w-5 text-[#1B7A45]" />
        <h2 className="font-display text-xl font-bold tracking-tight text-slate-900">Imagens de fundo (menu e Bar)</h2>
      </div>
      <p className="mt-1 text-sm text-slate-500">Fundos dos botões do menu e do topo do Bar. A cor original permanece como camada sobre a foto.</p>
      <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
        {SLUGS.map(({ slug, label }) => {
          const info = mbg[slug] || {};
          const src = info.present ? `${API}/settings/menu-bg/${slug}?v=${encodeURIComponent(info.updated_at || "")}` : null;
          return (
            <div key={slug} className="rounded-2xl border border-slate-200 bg-white p-3">
              <div className="relative h-24 overflow-hidden rounded-xl bg-[#0b1610]">
                {src && <img src={src} alt="" className="h-full w-full object-cover" />}
                <div className="absolute inset-0 flex items-end bg-black/30 p-2"><span className="text-xs font-bold text-white">{label}</span></div>
              </div>
              <input ref={(el) => (refs.current[slug] = el)} type="file" accept="image/*" onChange={(e) => onFile(slug, e)} className="hidden" data-testid={`menubg-input-${slug}`} />
              <div className="mt-2 flex gap-2">
                <Button data-testid={`menubg-upload-${slug}`} onClick={() => refs.current[slug]?.click()} size="sm" className="flex-1 rounded-xl bg-[#1B7A45] text-white hover:bg-[#156337]"><Upload className="mr-1 h-4 w-4" /> Enviar</Button>
                {info.present && <Button data-testid={`menubg-remove-${slug}`} onClick={() => remove(slug)} size="sm" variant="outline" className="rounded-xl border-red-200 bg-red-50 text-red-600"><Trash2 className="h-4 w-4" /></Button>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
